module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6KVp4LWFAAeqEe2y2s002-7309f70fae4908360956d221513c0a6e.jpg";